import { createSlice, PayloadAction } from '@reduxjs/toolkit'
import { IModalBase } from '../../interfaces/commonInterfaces'
import moment from 'moment'

export interface ShipmentState {
  shipmentList?: unknown
  shipmentOptionList?: unknown
  shipmentDetail?: unknown
  reloadShipmentList?: string | null
  modalShipment?: IModalBase
}

const initialState: ShipmentState = {
  shipmentList: {},
  shipmentOptionList: {},
  shipmentDetail: {},
  reloadShipmentList: null,
  modalShipment: {
    visible: false,
    record: {},
  },
}

export const shipmentDucks = createSlice({
  name: 'shipment',
  initialState,
  reducers: {
    getListShipment: (state, action: PayloadAction<string | undefined>) => {
      state.shipmentList = { loading: true, queryStr: action.payload }
    },
    getListShipmentSuccess: (state, action: PayloadAction<unknown>) => {
      state.shipmentList = { loading: false, ...(action.payload as object) }
    },
    getListShipmentFail: (state, action: PayloadAction<unknown>) => {
      state.shipmentList = { loading: false, ...(action.payload as object) }
    },

    getListOptionShipment: (state, action: PayloadAction<string | undefined>) => {
      state.shipmentOptionList = { loading: true, queryStr: action.payload }
    },
    getListOptionShipmentSuccess: (state, action: PayloadAction<unknown>) => {
      state.shipmentOptionList = { loading: false, ...(action.payload as object) }
    },
    getListOptionShipmentFail: (state, action: PayloadAction<unknown>) => {
      state.shipmentOptionList = { loading: false, ...(action.payload as object) }
    },

    getDetailShipment: (state, action: PayloadAction<string | number>) => {
      state.shipmentDetail = { loading: true, id: action.payload }
    },
    getDetailShipmentSuccess: (state, action: PayloadAction<unknown>) => {
      state.shipmentDetail = { loading: false, ...(action.payload as object) }
    },
    getDetailShipmentFail: (state, action: PayloadAction<unknown>) => {
      state.shipmentDetail = { loading: false, ...(action.payload as object) }
    },

    setReloadShipmentList: (state) => {
      state.reloadShipmentList = String(moment())
    },
    setModalShipment: (state, action: PayloadAction<IModalBase>) => {
      state.modalShipment = action.payload
    },
  },
})

export const {
  getListShipment,
  getListShipmentSuccess,
  getListShipmentFail,
  getListOptionShipment,
  getListOptionShipmentSuccess,
  getListOptionShipmentFail,
  getDetailShipment,
  getDetailShipmentSuccess,
  getDetailShipmentFail,
  setReloadShipmentList,
  setModalShipment,
} = shipmentDucks.actions

export default shipmentDucks.reducer
